import React from 'react';

interface FormProgressProps {
  step?: number;
  steps?: number;
}

export function FormProgress({ step, steps }: FormProgressProps) {
  if (!step || !steps) {
    return null;
  }

  return (
    <div className="form-progress">
      <div className="progress-bar">
        <div className="progress" style={{ width: `${(step / steps) * 100}%` }} />
      </div>
    </div>
  );
}
